module.exports = __webpack_public_path__ + "static/media/exit.0aebae28.png";